import cx from 'classnames'
import styles from './IconButton.module.scss'
import Icon from '../Icon'
import { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import React, { CSSProperties } from 'react'

type IconButtonProps = {
    icon: IconDefinition
    color: string
    onClick: () => void
    style?: CSSProperties
    children?: React.ReactNode
    classes?: string
    title?: string
}

const IconButton: React.FC<IconButtonProps> = ({
    icon,
    color,
    onClick,
    style,
    children,
    classes,
    title,
}) => {
    return (
        <button
            className={cx(styles['zr-icon-button'], classes)}
            onClick={onClick}
            style={style}
            type={'button'}
            title={title}
        >
            <Icon icon={icon} color={color} />
            {children && <div className={'zr-ml-2'}>{children}</div>}
        </button>
    )
}

export default IconButton
